import "./NotificationsTable.css";
import Table from "../../../Components/Table/Table";

const NotificationsTable = ({ data, onNotificationDeleted, pagination }) => {

  if (!data) {
    return <></>;
  }

  const columns = [
    {
      header: 'Subject',
      accessor: 'subject',
      render: (row) => (
        <button className="TableLink">{row.subject}</button>
      )
    },
    {
      header: 'Description',
      accessor: 'description'
    }

  
  ];

  return (
    <Table 
      columns={columns}
      data={data}
      emptyMessage="No notifications found"
      rowKey="notification_id"
      pagination={pagination}
    />
  );
};

export default NotificationsTable;
